export default __webpack_public_path__ + "static/media/outcomes.c1de3ae4.png";